(function() {
    const UPSELL_NAV = document.querySelector('.upselling-nav'),
          UPSELL_CATALOG = document.querySelector('.upselling-catalog'),
          UPSELL_ATC = UPSELL_CATALOG.querySelectorAll('.tile .btn-cart-add'),
          UPSELL_SWATCHES = UPSELL_CATALOG.querySelectorAll('.tile .swatches button');

    function sanitizeImageUrl(url) {
        if (!url) { return ''; }
        try {
            const parsed = new URL(url, window.location.origin);
            if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
                return parsed.href;
            }
        } catch (e) {}
        return '';
    }

    // Swatch click event
    function upselling_switch_variant(element) {
        let curr_swatch = element,
            curr_tile = curr_swatch.closest('.tile'),
            curr_img = curr_tile.querySelector('.tile-img img'),
            curr_title = curr_tile.querySelector('.variant-title'),
            curr_secondary_text = curr_tile.querySelector('.text-secondary.small .mt-1'),
            curr_price_direct = curr_tile.querySelector('.price-direct'),
            curr_price_shopify = curr_tile.querySelector('.price-shopify'),
            curr_atc = curr_tile.querySelector('.btn-cart-add'),
            curr_variant_sku = curr_swatch.getAttribute('data-sku'),
            curr_variant_id = curr_swatch.getAttribute('data-variant-id'),
            curr_preorder_info = curr_tile.querySelector('.preorder-info[data-variant-id="' + curr_variant_id + '"]'),
            prev_swatch = curr_tile.querySelector('.swatches button.active'),
            prev_preorder_info = curr_tile.querySelector('.preorder-info.active');

        if ( curr_swatch == prev_swatch ) { return; }

        let product_title = curr_swatch.getAttribute('data-product-title'),
            new_img = sanitizeImageUrl(curr_swatch.getAttribute('data-img')),
            new_title = curr_swatch.getAttribute('data-variant-title'),
            new_price_direct = curr_swatch.getAttribute('data-direct'),
            new_price_shopify = curr_swatch.getAttribute('data-shopify'),
            new_status = curr_swatch.getAttribute('data-status');

        if ( !new_img ) { return; }
        curr_tile.classList.remove('tile-confirmed');
        if ( curr_img.classList.contains('lazy-loaded') ) {
            curr_img.src = new_img;
        } else {
            curr_img.setAttribute('data-src', new_img);
        }
        // Update main title to show product title, secondary text to show variant title
        if ( curr_title.textContent != product_title ) { curr_title.textContent = product_title; }
        if ( curr_secondary_text && curr_secondary_text.textContent != new_title ) { curr_secondary_text.textContent = new_title; }
        if ( prev_preorder_info ) { prev_preorder_info.classList.remove('active'); }
        if ( curr_preorder_info ) { curr_preorder_info.classList.add('active'); }
        prev_swatch?.classList?.remove('active');
        curr_swatch?.classList?.add('active');
        if(curr_price_direct){
            curr_price_direct.textContent = new_price_direct > new_price_shopify ? currency_symbol + new_price_direct : '';
        }
        if(curr_price_shopify){
            curr_price_shopify.textContent = new_price_shopify;
        }
        curr_atc.setAttribute('data-status', new_status);
        curr_atc.setAttribute('data-sku', curr_variant_sku);

        if ( new_status == 'out-of-stock' || new_status == 'not-available' || new_status == 'register-interest' ) {
            curr_atc.setAttribute('data-notify-popup', '')
        } else {
            curr_atc.removeAttribute('data-notify-popup')
        }
    };

    // Upselling ATC Event
    function upselling_atc(element) {
        let curr_atc = element.classList.contains('btn-cart-add') ? element : element.closest('.btn-cart-add'),
            curr_tile = curr_atc.closest('.tile'),
            curr_swatch = curr_tile.querySelector('.swatches button.active'),
            curr_info = curr_swatch ? curr_swatch : curr_tile;

        if ( curr_atc.getAttribute('data-status').match(/(out-of-stock|not-available|register-interest)/) ) { return; }

        curr_tile.classList.add('tile-loading');

        let dataTable = { items: [] },
            dataTableExtra = { items: [] },
            dataFallback = '',
            datalayer_array = [];

        const objSKU = curr_info.getAttribute('data-sku'),
              sku_data = dataarray_variable.product_data.find((array) => { return array.id === objSKU });

        dataTable.items.unshift({ quantity: 1, id: curr_info.getAttribute('data-variant-id') });
        dataTableExtra.items.unshift({ quantity: 1, id: curr_info.getAttribute('data-variant-id'), name: curr_info.getAttribute('data-product-title'), price: curr_info.getAttribute('data-price'), type: curr_info.getAttribute('data-type') });

        dataTable.items.forEach(function(obj, i) {
            dataFallback = dataFallback + (i > 0 ? '&' : '') + 'id[]=' + obj.id + '&quantity=' + obj.quantity;
        });

        if ( sku_data ) {
            datalayer_array.push(sku_data);
        } else {
            whenAvailable('Sentry', () => {
                Sentry.captureException(new Error('[SLE] Missing dataarray_variable.product_data[SKU]: ' + objSKU + ' | file : upselling.js'));
            });
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(dataTable)
        }).then(response => {
            if (response.status >= 200 && response.status < 300) {
                window.dispatchEvent(new CustomEvent('eventATC', {detail: dataTableExtra}));
                datalayer_event('add_to_cart', datalayer_array);

                curr_tile.classList.remove('tile-loading');
                curr_tile.classList.add('tile-success', 'tile-confirmed');

                if ( document.querySelector('.template-cart') ) {
                    whenAvailable('$', function(){
                        $.secretlabCart.cartRefresh();
                    });
                }
            } else if (response.status == 422) {
                curr_tile.classList.remove('tile-loading');
                curr_tile.classList.add('tile-error');
            } else {
                window.location.href = locale_root+'/cart/add?'+dataFallback;
            }

            setTimeout(function() {
                curr_tile.classList.remove('tile-success', 'tile-error');
            }, 2500);
        }).catch(error => {
            window.location.href = locale_root+'/cart/add?'+dataFallback;
        });
    }

    // Initialize event listeners
    UPSELL_SWATCHES.forEach( element => element.addEventListener('click', event => upselling_switch_variant(event.target)) );
    UPSELL_ATC.forEach( element => element.addEventListener('click', event => {upselling_atc(event.target); }) );

    // If on upselling page
    let upsellingSearchParams = new URLSearchParams(window.location.search);
    if ( typeof upselling_product_list != 'undefined' ) {
        const title_object = {
            title: document.querySelector('.upselling-title'),
            subtitle: document.querySelector('.upselling-subtitle'),
            has_acc: document.querySelector('.upselling-has-acc')
        }

        paramSKU = upsellingSearchParams.get('sku') || "",
        bundlewithSku = upsellingSearchParams.get('bundlewithsku') || "",
        paramAcc = upsellingSearchParams.get('accessories') ? true : false;
        let upselling_has_sku = false;

        for (key in upselling_product_list) {
            if ( upselling_product_list[key][paramSKU] ) {
                let upselling_title = key + (upselling_product_list[key][paramSKU] !== '-' && upselling_product_list[key][paramSKU] !== key ? ' - ' + upselling_product_list[key][paramSKU] : ''),
                    upselling_subtitle = '';

                if ( (upselling_title.match(/-/g) || []).length > 1 ) {
                    upselling_subtitle = upselling_title.substring(upselling_title.indexOf(' - ')).slice(3);
                    upselling_title = upselling_title.substring(0, upselling_title.indexOf(' - '));
                }
                if(bundlewithSku.includes('4M-DESKB15S')) {
                    upselling_title = `Secretlab MAGNUS Metal Desk 1.5m + ${upselling_title}`;
                }
                title_object.title.innerHTML = upselling_title;
                title_object.title.style.display = null;

                if ( title_object.subtitle && upselling_subtitle ) {
                    title_object.subtitle.innerHTML = upselling_subtitle;
                    title_object.subtitle.style.display = null;
                }

                if ( paramAcc ) {
                    title_object.has_acc.style.display = null;
                }

                upselling_has_sku = true;
            }
        }

        if (typeof minspend_sku != 'undefined' && typeof minspend_sku_type != 'undefined' && paramSKU) {
            if ((minspend_sku_type == 'blacklist' && minspend_sku.indexOf(paramSKU) === -1) || (minspend_sku_type == 'whitelist' && minspend_sku.indexOf(paramSKU) > -1)) {
                document.querySelectorAll('.min-spend-callout').forEach((elem) => {
                    elem?.classList.remove('d-none')
                });
            }
        }
    }

    // If on cart page
    if ( document.querySelector('.template-cart') ) {
        if ( document.querySelectorAll('.upselling-catalog .tile').length < 2 ) {
            document.querySelector('#upselling_catalog').style.display = 'none';
        } else {
            const upselling_catalog = document.querySelector('.upselling-catalog'),
                  upselling_catalog_tile_order = {
                      4: upselling_catalog.querySelectorAll('.tile[class*="order-4"]'),
                      3: upselling_catalog.querySelectorAll('.tile[class*="order-3"]'),
                      2: upselling_catalog.querySelectorAll('.tile[class*="order-2"]'),
                      1: upselling_catalog.querySelectorAll('.tile[class*="order-1"]')
                  }

            // Re-order elements by css flex order, on DOM level.
            // Slick.js is unable to adjust adaptive height according to css flex order.
            for (tile_order in upselling_catalog_tile_order) {
                upselling_catalog_tile_order[tile_order].forEach(element => {
                    upselling_catalog.appendChild(element);
                });
            }

            whenAvailable('$', function() {
                whenAvailable('slick', function() {
                    $(upselling_catalog)?.slick({
                        prevArrow: '<button type="button" aria-label="Previous" class="arrow-prev"><svg class="svg-inline--fa fa-chevron-left fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path></svg></button>',
                        nextArrow: '<button type="button" aria-label="Next" class="arrow-next"><svg class="svg-inline--fa fa-chevron-right fa-w-10" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" data-fa-i2svg=""><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path></svg></button>',
                        infinite: false,
                        mobileFirst: true,
                        centerMode: true,
                        centerPadding: '30px',
                        slidesToShow: 1,
                        adaptiveHeight: true,
                        responsive: [
                            {
                                breakpoint: 571,
                                settings: {
                                    initialSlide: 1,
                                    slidesToShow: 2,
                                    centerPadding: '60px'
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    centerMode: false,
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 1900,
                                settings: {
                                    centerMode: false,
                                    slidesToShow: 4
                                }
                            }
                        ]
                    });
                });
            });
        }
    }
})();